import { TextInputProps } from "./InputProps";

import "./TextInput.scss";

const TextInput: React.FC<TextInputProps> = ({ value, handleFieldChange, fieldsetId, field, onBlur }) => {
    return (
        <>
            <div className="fee-calc-text-input">
                <label
                    htmlFor={`textfield_${fieldsetId}_${field.id}`}
                    className={`${field.labelHidden ? " visually-hidden" : ""}`}
                >
                    <i className="fa fa-asterisk" aria-hidden="true" title="Required"></i>
                    <span className="sr-only">Required</span>
                    {field.label}
                </label>
                {onBlur ? (
                    <input
                        type={field.type}
                        id={`textfield_${fieldsetId}_${field.id}`}
                        value={value}
                        onChange={(event) => handleFieldChange(event.target.value)}
                        onBlur={(event) => onBlur(event.target.value)}
                        required
                        min={field.min ? field.min : "0"}
                        step={field.step ? field.step : "1"}
                    />
                ) : (
                    <input
                        type={field.type}
                        id={`textfield_${fieldsetId}_${field.id}`}
                        value={value}
                        onChange={(event) => handleFieldChange(event.target.value)}
                        required
                        min={field.min ? field.min : "0"}
                        step={field.step ? field.step : "1"}
                    />
                )}
            </div>
        </>
    );
};

export default TextInput;
